import React from 'react'
import { toast, cssTransition } from 'react-toastify';
import CrossIcon from '../../img/icons/Cross';
import 'react-toastify/dist/ReactToastify.css';
import ToastContent from './toastContent';
import { isNullOrUndefined } from '../../store/storeFunctions';

import './toast.scss';

const Slide = cssTransition({
    enter: "slide-in-right",
    exit: "slide-out-right",
    duration: [450, 750],
    appendPosition: false
});

const Close = ({ closeToast }) => <div className="close-button"><CrossIcon onClick={closeToast} /></div>;

function toastMessage(notification, color){
    toastNotification({description: notification, color: color})
}

function toastNotification(notification) {
    toast(
        <ToastContent notification={notification}/>
        , {
            hideProgressBar: notification.hideProgressBar || true,
            transition: Slide,
            autoClose: notification.autoCloseAfter || 8000,
            closeOnClick: false,
            draggable: false,
            closeButton: <Close />,
            type: getType(notification)
        });
}

function getType(notification){
    if(isNullOrUndefined(notification.color))
        return toast.TYPE.DEFAULT;
    switch(notification.color.toLowerCase()){
        case "success": return toast.TYPE.SUCCESS;
        case "error": return toast.TYPE.ERROR;
        case "warn": return toast.TYPE.WARNING;
        case "info": return toast.TYPE.INFO;
        default: return toast.TYPE.DEFAULT;
    }

}
export { toastMessage as toast, toastNotification}